export default "__VITE_ASSET__CGsQJomP__"